module.exports = __webpack_public_path__ + "img/flsx.88a3034e.jpg";